export type DevNoteTrustTier = "owner_direct" | "needs_review";
export type DevNoteReviewStatus = "pending" | "approved" | "approved_altered" | null;

export type DevNotePlacement = {
  repo_path?: string;
  component_hint?: string;
  usage_hint?: string;
};

export type DevActionableNote = {
  id: string;
  created_by_user_id: string;
  organization_id: string | null;
  bug_report_id: string | null;
  body: string;
  effective_body: string | null;
  metadata: Record<string, unknown> | null;
  status: "open" | "awaiting_answer" | "in_progress";
  trust_tier: DevNoteTrustTier;
  review_status: DevNoteReviewStatus;
  reviewed_by_user_id: string | null;
  reviewed_at: string | null;
  reviewer_note: string | null;
  clarifying_questions: string | null;
  user_answer: string | null;
  created_at: string;
  updated_at: string;
  /** Present when list/export attaches a signed Storage URL for metadata.asset */
  asset_preview_url?: string | null;
  asset_mime?: string | null;
};

export function noteSyncBody(note: DevActionableNote): string {
  if (note.effective_body?.trim()) return note.effective_body.trim();
  return note.body;
}

export function notePlacement(note: DevActionableNote): DevNotePlacement | null {
  const p = note.metadata?.placement;
  if (!p || typeof p !== "object") return null;
  const o = p as Record<string, unknown>;
  const repo_path = typeof o.repo_path === "string" ? o.repo_path : "";
  if (!repo_path) return null;
  return {
    repo_path,
    component_hint: typeof o.component_hint === "string" ? o.component_hint : undefined,
    usage_hint: typeof o.usage_hint === "string" ? o.usage_hint : undefined,
  };
}

export function noteExportsToSync(note: DevActionableNote): boolean {
  if (note.trust_tier === "owner_direct") return true;
  return note.review_status === "approved" || note.review_status === "approved_altered";
}

export function noteHasAsset(note: DevActionableNote): boolean {
  const asset = note.metadata?.asset;
  if (!asset || typeof asset !== "object") return false;
  const o = asset as Record<string, unknown>;
  return typeof o.bucket === "string" && typeof o.path === "string";
}

export function noteAssetIncludeInSync(note: DevActionableNote): boolean {
  if (!noteHasAsset(note)) return false;
  return note.metadata?.asset_include_in_sync !== false;
}
